import mergeOperations from "@/util/shallowMerge"
import {
  useMutation
} from "@apollo/client"
import {
  useCallback, useMemo, useRef, useState
} from "react"
import DEFAULT_OPERATIONS from "./nurseDiscount.gql"

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const {
    afterSubmit, uploadRef 
  } = props
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)

  const {
    addMilitaryDiscountMutation 
  } = operations

  const formApiRef = useRef(null)

  const [isLoading, setIsLoading] = useState(false)
  const [isUploadImage, setIsUploadImage] = useState(false)
  const [addMilitaryDiscount, {
    data, error: addMilitaryDiscountError 
  }] =
        useMutation(addMilitaryDiscountMutation, {
          fetchPolicy: "no-cache",
        })

  const handleSubmit = useCallback(
    async (formState) => {
      const {
        firstname, lastname, email 
      } = formState.values

      setIsLoading(true)

      try {
        const {
          fileList, setFileList 
        } = uploadRef.current

        let image

        if (fileList.length) {
          image = fileList[0].thumbUrl
          setIsUploadImage(false)
        } else {
          setIsLoading(false)
          setIsUploadImage(true)

          return false
        }

        await addMilitaryDiscount({
          variables: {
            firstname,
            lastname,
            email,
            image,
            type_id: 4
          },
        })

        if (formApiRef.current) {
          formApiRef.current.reset()
        }

        setFileList([])

        if (afterSubmit) {
          afterSubmit()
        }
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error(error)
        }
      } finally {
        setIsLoading(false)
      }
    },
    [addMilitaryDiscount, afterSubmit, uploadRef]
  )

  const errors = useMemo(
    () => new Map([["addMilitaryDiscountError", addMilitaryDiscountError]]),
    [addMilitaryDiscountError]
  )

  return {
    formApiRef,
    isLoading,
    errors,
    handleSubmit,
    response: data && data.addDiscountInfo,
    isUploadImage,
  }
}
